import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const boardsDirectoryRoute: InvariantJiraRoute = {
	name: 'boards-directory',
	path: '/jira/boards',
};
